import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Row } from "reactstrap";
import Counter from "../Counter";
import { NavLink } from "react-router-dom";
import { PAYMENT_ERROR_TIMEOUT } from "../../Constants";

const PaymentFailed = (preps) => {
  const { lang, trans, handleCancel, timeoutEnabled = true } = preps;
  const { t } = useTranslation();

  return (
    <>
      <Card className='d-flex align-items-center justify-content-center flex-wrap py-10'>
        <div className='mt-4 mb-4'>
          <h3>{t("payment_failed")}</h3>
        </div>
        <div className='mb-3'>{t("status-error-text")}</div>
        {timeoutEnabled && <Counter counterTimeout={PAYMENT_ERROR_TIMEOUT} onTimeout={handleCancel} color='info' />}
        <Row className='my-3'>
          <NavLink to={"/payment/" + trans + "?lang=" + lang}>
            <Button color='danger' size='sm' className='mt-2 mb-4 mx-4'>
              {t("redirect-tryagain")}
            </Button>
          </NavLink>
          <Button color='info' size='sm' className='mt-2 mb-4 mx-4' onClick={handleCancel}>
            {t("cancel")}
          </Button>
        </Row>
      </Card>
    </>
  );
};

export default PaymentFailed;
